module.exports = __webpack_public_path__ + "img/mercadolibre.0d2a59c6.png";